import React from "react";
import classNames from "classnames";

interface RightHandFlyoutProps {
  isActive: boolean;
  expandWhenRequired: () => void;
}

const rightHandFlyout: React.SFC<RightHandFlyoutProps> = (props) => {
  const activeState = classNames({
    "buyers-tools": true,
    active: props.isActive,
    inactive: !props.isActive,
  });

  return (
    <div className={activeState} onMouseEnter={props.expandWhenRequired}>
      <div className="buyers-tools-inner">
        <ul className="buyers-tools-nav">
          <li className="buyers-tool buyers-tool-0">
            <i className="icon icon-1-5x icon-tools-build"></i>
            <a href="configure">Build Your Own</a>
          </li>
          <li className="buyers-tool buyers-tool-1">
            <i className="icon icon-1-5x icon-steering-wheel-2"></i>
            <a href="book-test-drive">Book A Test Drive</a>
          </li>
          <li className="buyers-tool buyers-tool-2">
            <i className="icon icon-1-5x icon-brochure"></i>
            <a href="brochure-download">Request A Brochure</a>
          </li>
          <li className="buyers-tool buyers-tool-3">
            <i className="icon icon-1-5x icon-find"></i>
            <a href="dealers">Find A Retailer</a>
          </li>
          <li className="buyers-tool buyers-tool-4">
            <i className="icon icon-1-5x icon-briefcase"></i>
            <a href="service-booking">Book a Service</a>
          </li>
          <li className="buyers-tool buyers-tool-5">
            <i className="icon icon-1-5x icon-dollar-circle"></i>
            <a href="showroom">Vehicle Pricing</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default rightHandFlyout;
